import React from 'react';
import {PlaceholderSlidesWrap} from './styled';
import range from 'lodash/range';
import {PLACEHOLDER_IMAGE_PATH} from '@/misc/constants';

const Placeholder = () => {
  return (
    <PlaceholderSlidesWrap>
      {range(0, 7).map(n => (
        <img
          key={n}
          src={PLACEHOLDER_IMAGE_PATH}
          role="presentation"
        />
      ))}
    </PlaceholderSlidesWrap>
  );
};

export default Placeholder;
